import AppDropdown from "@/components/AppDropdown.vue";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup.vue";
import { EVENTS } from "../utils";
import { PERIOD_OPTIONS_LEFT_RIGHT_EVENTS } from "../utils/constants";
export default {
  name: "PeriodControllers",
  components: {
    AppDropdown,
    AppButtonRadioGroup
  },
  props: {
    period: Object,
    periodCategory: Object,
    periodOptions: Array,
    periodSelectorOptions: Array
  },
  data() {
    return {};
  },
  computed: {
    currentPeriod: {
      get() {
        return this.period;
      },
      set(value) {
        this.$emit('update:period', value);
      }
    },
    currentPeriodCategory: {
      get() {
        return this.periodCategory;
      },
      set(value) {
        this.$emit('update:periodCategory', value);
        window.$bus.trigger(PERIOD_OPTIONS_LEFT_RIGHT_EVENTS[value]);
      }
    }
  }
};